import PackageRepository, {
  IPackageRelease
} from '@app/src/common/repository/PackageRepository';
import NotificationService from '@app/src/services/notification-service/NotificationService';
import AuthStore from '@app/src/common/store/AuthStore';
import { UserPermissions } from '@app/src/common/model/AuthModel';

interface IAboutModalStore {
  packageRelease: IPackageRelease | null;
  version: string | null;
  fetchPlayerInfo: () => Promise<void>;
}

export const createStore = (): IAboutModalStore => ({
  packageRelease: null,
  version: null,
  async fetchPlayerInfo() {
    try {
      const hasDownloadPerm = AuthStore.hasOneOfPermissions([
        UserPermissions.devicemanagement_view_device_company,
        UserPermissions.devicemanagement_view_device_own,
        UserPermissions.devicemanagement_view_device_all
      ]);
      const [packageResponse, versionResponse] = await Promise.all([
        hasDownloadPerm
          ? PackageRepository.getPackageRelease()
          : Promise.resolve({ packageReleases: [] }),
        PackageRepository.getPlatformVersion()
      ]);
      this.packageRelease = packageResponse.packageReleases[0] ?? null;
      this.version = versionResponse.productVersion;
    } catch (e) {
      NotificationService.errorMessage('notification.data.fetch.failed');
    }
  }
});
